module.exports = __webpack_public_path__ + "static/media/Picture11.8380af0f.png";